import Page from './Page';
import './Page.scss';

export default Page
